export enum UnclearReason {
  INCOMPLETE_RESEARCH = "incomplete_research",
  UNGRADABLE_EVIDENCE = "ungradable_evidence",
}

export const dataByUnclearReason: Record<UnclearReason, { label: string }> = {
  [UnclearReason.INCOMPLETE_RESEARCH]: { label: "Research incomplete" },
  [UnclearReason.UNGRADABLE_EVIDENCE]: { label: "Evidence can't be graded" },
}
